<div class="max-w-5xl">
	<ui-section title="RE Lines">
		<atomic-button-group
			[(ngModel)]="currentMatterType"
			[options]="matterTypes"
			actions
		></atomic-button-group>
		<div section-content class="flex flex-col gap-6">
			<div class="flex flex-col gap-4">
				<h4>Client</h4>
				<div class="flex justify-between">
					<p>Tag: <code>salutations.reLineClients</code></p>
					<p
						class="cursor-pointer"
						(click)="
							edit(
								'client',
								reLines.reLineClientsByType[currentMatterType],
								'salutations.reLineClients'
							)
						"
					>
						<i-tabler name="edit" class="w-5 h-5"></i-tabler>
					</p>
				</div>
			</div>

			<div class="flex flex-col gap-4">
				<h4>General</h4>
				<div class="flex justify-between">
					<p>Tag: <code>salutations.reLineGeneral</code></p>
					<p
						class="cursor-pointer"
						(click)="
							edit(
								'general',
								reLines.reLineGeneralByType[currentMatterType],
								'salutations.reLineGeneral'
							)
						"
					>
						<i-tabler name="edit" class="w-5 h-5"></i-tabler>
					</p>
				</div>
			</div>

			<div class="flex flex-col gap-4">
				<h4>Condensed</h4>
				<div class="flex justify-between">
					<p>Tag: <code>salutations.reLineCondensed</code></p>
					<p
						class="cursor-pointer"
						(click)="
							edit(
								'condensed',
								reLines.reLineCondensedByType[currentMatterType],
								'salutations.reLineCondensed'
							)
						"
					>
						<i-tabler name="edit" class="w-5 h-5"></i-tabler>
					</p>
				</div>
			</div>

			<div class="flex justify-between items-center">
				<h4 class="">Default Email Subject</h4>
				<p
					*ngIf="currentMatterType === 'sale'"
					class="cursor-pointer"
					(click)="edit('emailSubject', emailSubjectSale, 'emailSubject')"
				>
					<i-tabler name="edit" class="w-5 h-5"></i-tabler>
				</p>
				<p
					*ngIf="currentMatterType === 'purchase'"
					class="cursor-pointer"
					(click)="edit('emailSubject', emailSubjectPurchase, 'emailSubject')"
				>
					<i-tabler name="edit" class="w-5 h-5"></i-tabler>
				</p>
				<p
					*ngIf="currentMatterType === 'refinance'"
					class="cursor-pointer"
					(click)="edit('emailSubject', emailSubjectRefinance, 'emailSubject')"
				>
					<i-tabler name="edit" class="w-5 h-5"></i-tabler>
				</p>
			</div>
		</div>
	</ui-section>

	<ui-section title="Others" class="mt-6">
		<div section-content class="flex flex-col gap-6">
			<div class="flex flex-col gap-4">
				<h5>Encumbrance</h5>
				<div class="flex justify-between">
					<p>Tag: <code>encumbrances.id.reLine</code></p>
					<p
						class="cursor-pointer"
						(click)="
							edit(
								'encumbrances',
								reLines.reLineEncumbrances,
								'encumbrances.id.reLine'
							)
						"
					>
						<i-tabler name="edit" class="w-5 h-5"></i-tabler>
					</p>
				</div>
			</div>
			<div class="flex flex-col gap-4">
				<h5>Mortgage</h5>
				<div class="flex justify-between">
					<p>Tag: <code>mortgages.id.reLine</code></p>
					<p
						class="cursor-pointer"
						(click)="
							edit('mortgages', reLines.reLineMortgages, 'mortgages.id.reLine')
						"
					>
						<i-tabler name="edit" class="w-5 h-5"></i-tabler>
					</p>
				</div>
			</div>
			<div class="flex flex-col gap-4">
				<h5>Debt</h5>
				<div class="flex justify-between">
					<p>Tag: <code>debts.id.reLine</code></p>
					<p
						class="cursor-pointer"
						(click)="edit('debts', reLines.reLineDebts, 'debts.id.reLine')"
					>
						<i-tabler name="edit" class="w-5 h-5"></i-tabler>
					</p>
				</div>
			</div>
		</div>
	</ui-section>

	<ui-section title="Document Options" class="mt-6">
		<div section-content class="flex flex-col gap-6">
			<ng-container>
				<div class="flex justify-between">
					<h5>Downloaded Document Title</h5>
					<p
						class="cursor-pointer"
						(click)="
							edit(
								'downloadedDocumentTitle',
								downloadedDocumentTitle,
								'downloadedDocumentTitle'
							)
						"
					>
						<i-tabler name="edit" class="w-5 h-5"></i-tabler>
					</p>
				</div>
			</ng-container>
			<div class="flex flex-col gap-4">
				<h5>In Person Signing Jurat</h5>
				<p>
					<i
						>(SEVERALLY) will be added at the beginning if more than one person
						is signing</i
					>
				</p>
				<div class="flex justify-between">
					<p>Tag: <code>inPersonSigningJurat</code></p>
					<p
						class="cursor-pointer"
						(click)="
							edit(
								'inPersonSigningJurat',
								inPersonSigningJurat,
								'inPersonSigningJurat'
							)
						"
					>
						<i-tabler name="edit" class="w-5 h-5"></i-tabler>
					</p>
				</div>
			</div>
			<div class="flex flex-col gap-4">
				<h5>Remote Signing Jurat</h5>
				<p>
					<i
						>(SEVERALLY) will be added at the beginning if more than one person
						is signing</i
					>
				</p>
				<div class="flex justify-between">
					<p>Tag: <code>remoteSigningJurat</code></p>
					<p
						class="cursor-pointer"
						(click)="
							edit(
								'remoteSigningJurat',
								remoteSigningJurat,
								'remoteSigningJurat'
							)
						"
					>
						<i-tabler name="edit" class="w-5 h-5"></i-tabler>
					</p>
				</div>
			</div>
			<div class="flex flex-col gap-4">
				<h5>Yours Very Truly Signature Block</h5>
				<div class="flex justify-between">
					<p class="">Tag: <code>yoursTruly.lawyer</code></p>
					<p
						class="cursor-pointer"
						(click)="
							edit('yoursTrulyLawyer', yoursTrulyLawyer, 'yoursTruly.lawyer')
						"
					>
						<i-tabler name="edit" class="w-5 h-5"></i-tabler>
					</p>
				</div>
			</div>
			<div class="flex flex-col gap-4">
				<h5>Barrister & Solicitor Format</h5>
				<div class="flex justify-between">
					<div class="space-y-3">
						<p>
							Setting Default:
							{{ hasOfficeSettings() ? 'By Office' : 'By Firm' }}
						</p>
						<p>
							{{
								hasOfficeSettings()
									? 'Select edit for more details'
									: businessUseSingularBarristerSolicitor()
										? 'Singular'
										: 'Plural'
							}}
						</p>
					</div>
					<p class="cursor-pointer" (click)="editBarristerSolicitorFormat()">
						<i-tabler name="edit" class="w-5 h-5"></i-tabler>
					</p>
				</div>
			</div>

			<div class="flex flex-col gap-4">
				<h5>Date Line Format</h5>
				<div class="flex justify-between">
					<p [innerHTML]="dateLinePreviewText()"></p>
					<p class="cursor-pointer" (click)="editDateLineFormat()">
						<i-tabler name="edit" class="w-5 h-5"></i-tabler>
					</p>
				</div>
			</div>
		</div>
	</ui-section>
</div>
